<script>
import ieBooking from '@/views/cargo/v0/Integrated/ieBooking'

export default {
  name: 'TTIEBooking',
  extends: ieBooking,
  props: {
    integratedLogisticsType: {
      type: String,
      default: 'TT' // 设置默认值
    }
  }
}
</script>
